export default {
  "nav.thesis": "Thèse",
  "nav.disciplines": "Disciplines",
  "nav.horizon": "Horizon",
  "nav.join": "Postuler",
  "nav.backus": "S'abonner",
  "nav.invest": "Soutenez-nous",

  "hero.badge": "Ingénierie de la Longévité",
  "hero.l1": "L'immortalité humaine est théorique.",
  "hero.l2": "150 ans, c'est pratique.",
  "hero.sub": "La longévité est un défi humain multidisciplinaire. La Médecine et les Sciences de la Santé ont permis des avancées remarquables en longévité. Les prochaines percées pourraient naître de leur convergence avec l'ingénierie, l'IA, la neurologie, la psychologie, les sciences cognitives, la mécanique quantique, la physique des particules et l'espace-temps.",
  "hero.sub2": "The Lifespan Project réunit ces disciplines. Rien dans les lois connues de la physique ne semble interdire une vie humaine bien plus longue. Nous entendons étudier et prouver ce qui est possible.",
  "hero.cta1": "S'abonner au Projet",
  "hero.cta2": "Lire la Thèse",
  "hero.stats1": "09 Disciplines",
  "hero.stats2": "Échelle Subliminale",
  "hero.stats3": "Premières Solutions ≤ 24 Mois",
  "hero.caption": "Recherche à échelle subliminale en cours",

  "mq.1": "Espace-Temps",
  "mq.2": "Physique des Particules",
  "mq.3": "Mécanique Quantique",
  "mq.4": "Informatique IA",
  "mq.5": "Biologie",
  "mq.6": "Neurologie",
  "mq.7": "Psychologie",
  "mq.8": "Sciences Cognitives",
  "mq.11": "Sciences de la Santé",
  "mq.12": "Science Médicale",
  "mq.9": "Longévité",
  "mq.10": "150+ Ans",

  "mani.eyebrow": "Le Manifeste",
  "mani.h2a": "La mort est le plus ancien",
  "mani.h2b": "problème non résolu",
  "mani.h2c": "de la physique.",
  "mani.c1t": "La Thèse",
  "mani.c1b": "Le vieillissement n'est pas une loi de la nature; c'est un problème d'ingénierie non résolu. Nous sommes convaincus que l'être humain peut atteindre l'immortalité en théorie, et une vie au-delà de 150 ans en pratique, dans un avenir proche. Chaque discipline que nous abordons pointe dans la même direction.",
  "mani.c2t": "La Méthode",
  "mani.c2b": "Nos programmes de recherche et de calcul opèrent à échelle subliminale: sous le bruit, à travers toute la matière et l'esprit. Des interactions de particules au calcul neuronal, nous modélisons la vie comme un système qui peut être compris, simulé et prolongé.",
  "mani.c3t": "L'Horizon",
  "mani.c3b": "Ce n'est pas un projet d'un siècle. D'ici deux ans, nous déploierons nos premières solutions; les premiers artefacts d'un programme bien plus vaste. La suite se compose.",
  "mani.c4t": "Le Modèle",
  "mani.c4b": "Notre recherche est soutenue par un vaste écosystème: mécènes, investisseurs, abonnés académiques, philanthropes, grandes fortunes, entrepreneurs, entreprises partenaires et sponsors. Les produits et services circulent via The Lifespan Labs pour faire avancer la recherche; ils sont le moteur, jamais la finalité.",

  "disc.eyebrow": "La Structure",
  "disc.h2a": "Neuf disciplines.",
  "disc.more": "Comment ça converge",
  "disc.converge": "Médecine × Physique × Longévité",
  "disc.h2b": "Une variable.",
  "disc.sub": "La longévité n'est pas seulement un problème de biologie. C'est un problème systémique complet, des particules à la conscience.",
  "disc.d1n": "Espace-Temps et Matière",
  "disc.d1d": "La vie se déploie dans un tissu physique. Nous étudions comment la matière s'organise, persiste et se répare au fil du temps.",
  "disc.d1x": "La médecine mesure le vieillissement en années; la physique demande ce qu'est le temps lui-même. En étudiant comment la matière s'organise et persiste dans l'espace-temps, nous cherchons les leviers les plus profonds permettant aux systèmes vivants de résister à la dégradation.",
  "disc.d2n": "Physique des Particules",
  "disc.d2d": "Aux plus petites échelles se trouvent les règles que tout le reste suit.",
  "disc.d2x": "Chaque médicament, cellule et pensée est constitué de particules obéissant à des règles précises. Comprendre ces règles aux plus petites échelles permet à la médecine de concevoir des interventions avec une précision atomique plutôt que par approximation.",
  "disc.d3n": "Mécanique Quantique",
  "disc.d3d": "Cohérence, décohérence et la base quantique de la machinerie biologique.",
  "disc.d3x": "La vie fonctionne déjà sur une machinerie quantique : enzymes, photosynthèse et peut-être la cognition. Là où la médecine rencontre la physique quantique, nous explorons la cohérence, l'effet tunnel et la détection comme nouveaux outils pour lire et réparer la biologie.",
  "disc.d4n": "IA et Informatique",
  "disc.d4d": "La simulation et l'intelligence artificielle compressent des décennies d'essais biologiques en quelques jours de calcul.",
  "disc.d4x": "L'IA comprime des décennies d'essais médicaux en jours de simulation. Associée à des modèles physiques du corps, elle nous permet de tester molécules et thérapies in silico avant qu'elles n'atteignent un patient.",
  "disc.d5n": "Biologie",
  "disc.d5d": "Réparation cellulaire, sénescence et régénération: les leviers directs de la longévité.",
  "disc.d5x": "La biologie donne à la médecine ses cibles : réparation cellulaire, sénescence et régénération. Combinée à des mesures de précision physique, le vieillissement passe de mystère à spécification d'ingénierie.",
  "disc.d6n": "Neurologie",
  "disc.d6d": "Le cerveau est le noyau irremplaçable. Le protéger et le prolonger est non négociable.",
  "disc.d6x": "Le cerveau est là où la médecine ne peut pas encore remplacer ce qui défaille. La neurologie converge avec la physique et l'informatique pour protéger, interfacer et un jour étendre le noyau irremplaçable de ce que nous sommes.",
  "disc.d7n": "Psychologie et Sciences Cognitives",
  "disc.d7d": "Une vie plus longue doit rester une vie qui vaut la peine: esprit, mémoire et sens inclus.",
  "disc.d7x": "Une vie plus longue ne compte que si l'esprit s'épanouit. Les sciences cognitives et la médecine cartographient ensemble comment la mémoire, la motivation et le sens évoluent avec l'âge, pour que les années gagnées restent dignes d'être vécues.",
  "disc.d8n": "Sciences de la Santé",
  "disc.d8d": "La santé publique, la nutrition et la prévention, les leviers à l'échelle des populations qui ont déjà ajouté des décennies à la vie humaine.",
  "disc.d8x": "La santé publique a ajouté des décennies à la vie humaine sans un seul comprimé : assainissement, nutrition, prévention. Mesurés avec une précision physique, ces leviers de population deviennent une infrastructure programmable pour la longévité.",
  "disc.d9n": "Science Médicale",
  "disc.d9d": "La médecine clinique transforme la recherche sur la longévité en pratique : diagnostics, thérapies et soins qui prolongent les années en bonne santé.",
  "disc.d9x": "La médecine transforme chaque découverte en pratique. En convergeant avec la physique et l'ingénierie, le diagnostic, l'imagerie et les thérapies gagnent la résolution pour détecter tôt le vieillissement et l'inverser précisément.",

  "time.eyebrow": "L'Horizon",
  "time.h2a": "Deux ans avant les",
  "time.h2b": "premières solutions.",
  "time.m1t": "Maintenant",
  "time.m1h": "Recherche à Échelle Subliminale",
  "time.m1b": "Des programmes profonds de recherche et de calcul à grande échelle sont déjà en cours, discrètement, sous les radars, en physique, IA et biologie.",
  "time.m2t": "T + 12 Mois",
  "time.m2h": "Premières Interventions Candidates",
  "time.m2b": "Les premiers résultats validés du programme passent de la simulation à l'évaluation structurée.",
  "time.m3t": "T + 24 Mois",
  "time.m3h": "Déploiement des Premières Solutions",
  "time.m3b": "Nos premières solutions sont lancées. Le début d'une chaîne cumulative vers l'extension radicale de la vie.",
  "time.outro": "Restez à l'écoute. L'horloge tourne déjà.",

  "pipe.eyebrow": "La Pipeline",
  "pipe.h2a": "De la recherche fondamentale aux",
  "pipe.h2b": "solutions du monde réel.",
  "pipe.s1t": "Recherche Fondamentale",
  "pipe.s1tail": "et disciplines connexes.",
  "pipe.s2t": "Modèles et Découverte",
  "pipe.s3t": "Technologie",
  "pipe.s4t": "The Lifespan Labs",
  "pipe.s4d": "Un écosystème soigné de produits et services pour une vie plus saine, plus longue et meilleure.",
  "pipe.s5t": "L'Écosystème de la Vie Plus Longue",
  "pipe.s5tail": "et des solutions orientées longévité.",

  "back.eyebrow": "Le Programme",
  "back.h2a": "D'abord, l'",
  "back.h2b": "équation de l'immortalité.",
  "back.h2c": "Ensuite, tout ce qu'elle débloque.",
  "back.badge": "La preuve avant le produit",
  "back.copy": "Notre travail central est mathématique: une démonstration fondée sur la physique, l'équation de l'immortalité, qui formalise pourquoi le temps biologique peut être arrêté et inversé. Chaque solution que nous construisons en découle.",
  "back.cta1": "S'abonner au Projet",
  "back.cta2": "Soutenez-nous",

  "sub.eyebrow": "Restez Proche de la Recherche",
  "sub.h2a": "Abonnez-vous aux nouvelles.",
  "sub.h2b": "Rejoignez la communauté.",
  "sub.p": "Actualités de la recherche, publications et nouvelles de l'écosystème, directement dans votre boîte mail. Chaque nouvel abonné reçoit une Carte de Membre Digitale en tant que Prime Member, avec le premier mois offert.",
  "sub.success.h": "Bienvenue dans la communauté.",
  "sub.success.p": "Votre Carte de Membre Digitale en tant que Prime Member est ci-dessous, et une copie est en route vers votre boîte mail, avec votre premier mois offert.",
  "sub.download": "Télécharger la Carte de Membre",
  "sub.submit": "S'abonner aux Nouvelles",
  "sub.sending": "Abonnement en cours...",

  "form.name": "Nom complet",
  "form.email": "E-mail",
  "form.phone": "Numéro de contact",
  "form.country": "Pays",
  "form.city": "Ville",
  "form.ph.name": "Votre nom",
  "form.ph.country": "Inde",
  "form.ph.city": "Mumbai",
  "form.error": "Une erreur est survenue. Réessayez ou écrivez à invest@thelifespanproject.com.",
  "form.sending": "Envoi en cours...",

  "footer.desc": "Une initiative multidisciplinaire de recherche sur la longévité humaine, qui conçoit les 150 prochaines années de la vie humaine.",
  "footer.explore": "Explorer",
  "footer.contact": "Contact",
  "footer.legal": "Mentions légales",
  "footer.terms": "Conditions",
  "footer.privacy": "Politique de Confidentialité",
  "footer.refund": "Politique de Remboursement",
  "footer.faq": "FAQ",
  "footer.partners": "Partenaires Technologiques et Mécènes",
  "footer.copyright": "© 2026 The Lifespan Project. Tous droits réservés.",
  "footer.tagline": "L'immortalité est théorique. 150 ans, c'est pratique.",

  "pick.title": "Choisissez votre vue",
  "pick.sub": "Choisissez un thème pour commencer. Vous pouvez changer à tout moment depuis l'en-tête.",
  "pick.dark": "Sombre",
  "pick.dark.sub": "Cinématique",
  "pick.light": "Clair",
  "pick.light.sub": "Blanc dégradé",

  "cookie.text": "Ce site utilise des cookies essentiels et des analyses respectueuses de la vie privée. En continuant, vous acceptez notre",
  "cookie.accept": "Compris",

  "inv.badge": "Relations Investisseurs",
  "inv.h1a": "Investissez dans les",
  "inv.h1b": "150 prochaines années.",
  "inv.sub": "The Lifespan Project est une initiative multidisciplinaire de recherche sur la longévité humaine. Dites-nous qui vous êtes et notre équipe vous contactera avec le dossier investisseur complet.",
  "inv.perks.h": "Ce que reçoivent les investisseurs",
  "inv.perk1": "Dossier investisseur complet et feuille de route de la recherche",
  "inv.perk2": "Ligne directe avec l'équipe fondatrice",
  "inv.perk3": "Data room et documentation technique sur demande",
  "inv.perk4": "Visibilité anticipée sur la pipeline des solutions",
  "inv.next.h": "Et ensuite",
  "inv.next.p": "Vous recevez immédiatement un accusé de réception avec une copie de votre demande. Notre équipe vous contacte ensuite personnellement avec le dossier investisseur. Vous préférez l'e-mail? Écrivez à",
  "inv.org": "Organisation",
  "inv.ph.org": "Fonds, institution ou entreprise",
  "inv.interest": "Votre intérêt",
  "inv.ph.interest": "Taille du ticket, mandat, calendrier...",
  "inv.submit": "Demander le Dossier Investisseur",
  "inv.success.h": "Merci, demande bien reçue.",
  "inv.success.p": "Un accusé de réception avec une copie de votre demande est en route vers votre boîte mail. Notre équipe vous contactera très vite.",

  "join.badge": "Collaborez avec Nous",
  "join.h1a": "Rejoignez le laboratoire comme",
  "join.h1b": "collaborateur.",
  "join.sub": "Nous travaillons avec des chercheurs, cliniciens et professionnels d'exception, stagiaires et collaborateurs, sur l'équation de l'immortalité et tout ce qu'elle débloque.",
  "join.elig.h": "Conditions minimales",
  "join.elig1": "Doctorat, PhD, MBBS ou MD",
  "join.elig2": "Ou double spécialisation de troisième cycle, tout domaine",
  "join.elig3": "Professionnel en activité, où que ce soit",
  "join.elig4": "Au moins 5 ans d'expérience, en Inde ou à l'étranger",
  "join.next.h": "Et ensuite",
  "join.next.p": "Chaque candidature est examinée personnellement par notre équipe de recherche. Vous recevez immédiatement une copie par e-mail de votre envoi, et nous vous contactons en cas d'affinité.",
  "join.qual": "Diplôme le plus élevé",
  "join.qual.select": "Sélectionnez le diplôme",
  "join.disc": "Quelle discipline vous correspond le mieux ?",
  "join.disc.select": "Sélectionnez une discipline",
  "join.disc.unsure": "Pas encore sûr",
  "join.spec": "Spécialisation / domaine",
  "join.ph.spec": "ex. Biologie quantique, neurologie",
  "join.exp": "Années d'expérience",
  "join.ph.exp": "Min. 5",
  "join.role": "Poste actuel et organisation",
  "join.ph.role": "ex. Chercheur scientifique, CSIR",
  "join.why": "Pourquoi souhaitez-vous collaborer?",
  "join.ph.why": "Vos intérêts de recherche, publications, ce sur quoi vous travailleriez...",
  "join.ph.country": "Inde / étranger",
  "join.submit": "Postuler comme Collaborateur",
  "join.submitting": "Envoi en cours...",
  "join.success.h": "Candidature reçue.",
  "join.success.p": "Une copie de votre envoi est en route vers votre boîte mail. Notre équipe de recherche examine personnellement chaque candidature.",

  "bu.badge": "Faire progresser la science de la longévité humaine",
  "bu.h1a": "Devenez",
  "bu.h1b": "Membre Fondateur",
  "bu.h1c": "de The Lifespan Project.",
  "bu.sub": "L'avenir de la longévité humaine ne sera pas construit par une seule discipline, un seul laboratoire ou une seule technologie. Il sera construit par la recherche, l'expérimentation, la collaboration et la traduction du savoir scientifique en solutions tangibles. Votre adhésion soutient ce voyage.",
  "bu.projline": ": la recherche scientifique.",
  "bu.labsline": ": donner vie aux solutions de longévité.",

  "arch.eyebrow": "La Structure",
  "arch.h2a": "Une mission.",
  "arch.h2b": "Deux moteurs.",
  "arch.proj.h": "R&D Scientifique",
  "arch.labs.h": "Marketplace de la Longévité",

  "flow.1": "Recherche",
  "flow.2": "Validation",
  "flow.3": "Technologie",
  "flow.4": "Produits et Services",
  "flow.5": "Vie Plus Longue et Saine",

  "pos.eyebrow": "Ce que Signifie l'Adhésion",
  "pos.h2": "Vous ne vous abonnez pas simplement à du contenu.",
  "pos.p": "Vous rejoignez la communauté fondatrice derrière la recherche. L'adhésion soutient le développement continu de la recherche, du travail scientifique, du savoir, de l'expérimentation et de la future pipeline de solutions de The Lifespan Project. En retour, les Membres Fondateurs reçoivent une Adhésion Digitale de Fondateur qui les relie à l'écosystème Lifespan en croissance.",
  "pos.note": "L'adhésion ne garantit aucun résultat scientifique, aucun résultat de santé ni aucune augmentation de la longévité.",

  "eco.eyebrow": "Adhésion Digitale de Fondateur",
  "eco.h2a": "Votre adhésion s'étend",
  "eco.h2b": "au-delà de la recherche.",
  "eco.sub": "Chaque Membre Fondateur reçoit une Adhésion Digitale à l'écosystème Lifespan en croissance, y compris l'accès au futur marketplace The Lifespan Labs.",
  "eco.c1n": "Santé",
  "eco.c2n": "Alimentation et Nutrition",
  "eco.c3n": "Biomarqueurs et Laboratoires",
  "eco.c4n": "Médecins et Services de Santé",
  "eco.c5n": "Appareils et Machines",
  "eco.c6n": "Sport et Corps",
  "eco.c7n": "Guérison et Kinésithérapie",
  "eco.c8n": "Esprit et Psychologie",
  "eco.c9n": "Esprit · Corps · Âme",

  "ben.eyebrow": "Avantages du Membre Fondateur",
  "ben.h": "Ce que reçoivent les Membres Fondateurs",

  "mode.free": "Gratuit",
  "mode.monthly": "Mensuel",
  "mode.life": "À vie",
  "cad.month": "par mois",
  "cad.life": "à vie",
  "cad.free": "pour toujours",
  "cad.month.short": "mois",
  "reg.intl": "Hors Inde",
  "reg.in": "Inde",

  "plan.prime.tag": "La porte d'entrée de l'écosystème Lifespan.",
  "plan.prime.f1": "Carte de Membre Digitale de Fondateur avec code scannable",
  "plan.prime.f2": "Toute la recherche, contenus et vidéos publiés",
  "plan.prime.f3": "Accès à The Lifespan Labs au lancement",
  "plan.prime.f4": "Offres membres et tarifs préférentiels",
  "plan.prime.f5": "Soumettez vos recherches pour examen par les pairs",
  "plan.pro.tag": "Tout Prime, à vie. Plus le cercle restreint.",
  "plan.pro.f1": "Adhésion à vie, sans renouvellement",
  "plan.pro.f2": "Publications de recherche et exclusivités réservées aux Pro",
  "plan.pro.f3": "Invitations à des réunions et événements de recherche dans le monde",
  "plan.pro.f4": "Remises renforcées sur The Lifespan Labs",
  "plan.pro.f5": "Accès prioritaire aux nouveaux produits et services",
  "plan.well.tag": "Restez proche de la science, gratuitement.",
  "plan.well.f1": "Carte de Membre Digitale Wellwisher avec code",
  "plan.well.f2": "Actualités et nouvelles de la recherche",
  "plan.well.f3": "Premier informé du lancement de The Lifespan Labs",

  "cta.subscribe": "S'abonner Ici",
  "cta.free": "S'abonner Gratuitement",
  "cta.welllink": "S'abonner Gratuitement comme Wellwisher",

  "why.eyebrow": "Le Pourquoi",
  "why.h": "Pourquoi devenir Membre Fondateur?",
  "why.1t": "Soutenez la Recherche",
  "why.2t": "Accédez à l'Écosystème",
  "why.3t": "Découvrez la Suite",
  "why.4t": "Façonnez l'Avenir",

  "flowS.eyebrow": "Comment Tout se Relie",
  "flowS.h": "De la recherche à la communauté",
  "flowS.n1t": "R&D · Science · Recherche · Technologie",
  "flowS.n2t": "Produits · Services · Marketplace · Accès",
  "flowS.n3t": "Communauté · Accès · Participation",
  "flowS.proline": "Les Membres Fondateurs Pro peuvent recevoir des invitations à des réunions de recherche, conférences et événements de l'écosystème Lifespan Project dans le monde entier.",
  "net.caption": "Réseau mondial de recherche",

  "ck.eyebrow": "Devenez Membre Fondateur",
  "ck.h": "Activez votre adhésion",
  "ck.submit": "Continuer vers le Paiement Sécurisé",
  "ck.sending": "Ouverture du paiement sécurisé...",
  "ck.per.month": " / mois",
  "ck.per.life": " à vie",
  "ck.note1": "Enregistré comme abonnement",
  "ck.note2": ". Reçu et facture suivent par e-mail.",
  "ck.invite.toggle": "Vous avez un code d'invitation ?",
  "ck.invite.code": "Code d'invitation",
  "ck.invite.sending": "Application de votre invitation...",
  "ck.invite.submit": "Activer l'adhésion gratuite",
  "ck.invite.note": "Une invitation valide rend le plan sélectionné entièrement gratuit.",
  "ck.invite.ph": "Entrez votre code",
  "ck.inrnote": "Cartes internationales acceptées. Razorpay débite en INR au prix en roupies affiché.",
  "ck.orwell": "Pas encore prêt à soutenir la recherche?",

  "close.h2a": "Ne regardez pas seulement le",
  "close.h2b": "futur de la longévité.",
  "close.h2c": "Aidez à le construire.",
  "close.p": "The Lifespan Project construit la recherche. The Lifespan Labs réunira l'écosystème. Les Membres Fondateurs rendent ce voyage possible et font partie de ce qui vient.",
  "close.prime": "Devenir Membre Prime",
  "close.pro": "Devenir Membre Pro",
  "close.or": "ou",

  "res.h2a": "Une idée?",
  "res.h2b": "Apportez-la au Projet.",
  "res.cta": "Soumettez votre recherche",

  "ww.eyebrow": "Gratuit pour toujours",
  "ww.title": "Devenez Wellwisher Founding Member",
  "ww.sub": "Actualités et nouvelles de la recherche, et votre Carte de Membre Digitale Wellwisher avec code scannable, livrée instantanément.",
  "ww.success.p": "Bienvenue. Votre carte est ci-dessous, et une copie est en route vers votre boîte mail.",
  "ww.submitting": "Abonnement en cours...",

  "legal.notice": "Ce document juridique est fourni en anglais afin d'en préserver le sens exact.",

  "ui.language": "Langue",
  "ui.theme": "Thème",
};
